/**
 * GapSummaryBar — horizontal progress bar showing suggestion statuses.
 */
import type { GapSummary } from '../types';

interface Props {
  gapSummary: GapSummary;
}

export function GapSummaryBar({ gapSummary }: Props) {
  const total = gapSummary.totalSuggestions;
  if (total === 0) return null;

  const acceptedPct = (gapSummary.accepted / total) * 100;
  const rejectedPct = ((gapSummary.rejected ?? 0) / total) * 100;
  const pendingPct = (gapSummary.pendingReview / total) * 100;

  return (
    <div className="px-4 py-2 bg-gray-50 border-b border-gray-200">
      <div className="flex items-center justify-between text-2xs text-gray-500 mb-1">
        <span className="font-medium text-gray-700">Review Progress</span>
        <span>
          {gapSummary.accepted} of {total} accepted
          {(gapSummary.rejected ?? 0) > 0 && ` · ${gapSummary.rejected} rejected`}
        </span>
      </div>
      <div className="h-2 bg-gray-200 rounded-full overflow-hidden flex">
        {acceptedPct > 0 && (
          <div
            className="h-full bg-emerald-500 transition-all duration-500"
            style={{ width: `${acceptedPct}%` }}
          />
        )}
        {rejectedPct > 0 && (
          <div
            className="h-full bg-red-400 transition-all duration-500"
            style={{ width: `${rejectedPct}%` }}
          />
        )}
        {pendingPct > 0 && (
          <div
            className="h-full bg-blue-300 transition-all duration-500"
            style={{ width: `${pendingPct}%` }}
          />
        )}
      </div>
    </div>
  );
}
